module.exports = __webpack_public_path__ + "static/media/7.b64407c3.jpg";